import { render, staticRenderFns } from "./Projectmanagement.vue?vue&type=template&id=c528d914&scoped=true"
import script from "./Projectmanagement.vue?vue&type=script&lang=js"
export * from "./Projectmanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c528d914",
  null
  
)

export default component.exports